import { css } from 'styled-components';
import { CFTokens } from '../../tokens';
//
// Tokens
//
export const CFBaseBackgroundBlurTokens = {
    blurSize: CFTokens.BACKGROUND_BLUR_SIZE,
};
//
// Helpers
//
export const CFBaseBackgroundBlurHelpers = {};
//
// Element Styles
//
export const CFBaseBackgroundBlurStyles = {
    Root: css `
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  `,
};
